import { Modal } from 'antd';
import { useEffect, useState } from "react";

const View = ({ data, format, isOpen, onClose, fileName }) => {
  const [viewUrl, setViewUrl] = useState("");
  console.log("View component received - Data type:", typeof data, "Format:", format, "Data preview:", 
    typeof data === 'string' ? data.substring(0, 100) + '...' : Array.isArray(data) ? `Array[${data.length}]` : data);
    
  useEffect(() => {
    if (!data) return;

    const mimeType = {
      ".pdf": "application/pdf",
      ".png": "image/png",
      ".jpeg": "image/jpeg",
      ".jpg": "image/jpeg",
      ".doc": "application/msword",
      ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    }[format || ""];

    const type = mimeType || "application/octet-stream";
    
    try {
      let bytes;

      // Check if data is a byte array (V1 format)
      if (Array.isArray(data) || data instanceof Uint8Array) {
        console.log("Processing byte array (V1 format), length:", data.length);
        // Convert array to Uint8Array if needed
        bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
      } 
      // Check if data is a base64 string (V2 format)
      else if (typeof data === 'string') {
        console.log("Processing base64 string (V2 format), length:", data.length);
        console.log("Using MIME type:", type);
        
        // Clean and validate base64 string
        let cleanedData = data.replace(/ /g, '+');

        // Remove any data URI prefix if present
        if (cleanedData.includes(',')) {
          cleanedData = cleanedData.split(',')[1];
        }
        
        // Remove any whitespace and newlines
        cleanedData = cleanedData.replace(/\s/g, '');
        
        // Check if it's a valid base64 string
        const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
        if (!base64Regex.test(cleanedData)) {
          throw new Error('Invalid base64 format - contains invalid characters');
        }
        
        // Ensure proper padding
        while (cleanedData.length % 4) {
          cleanedData += '=';
        }
        
        console.log("Cleaned data length:", cleanedData.length);
        
        // Convert base64 string to binary
        const binaryString = atob(cleanedData);
        bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
      } else {
        console.error("Unsupported data format:", typeof data);
        return;
      }
      
      console.log("Creating blob with", bytes.length, "bytes");
      
      // Create blob with correct MIME type
      const blob = new Blob([bytes], { type });
      const dataUrl = URL.createObjectURL(blob);
      setViewUrl(dataUrl);
      
      console.log("Created blob URL successfully");

      return () => {
        URL.revokeObjectURL(dataUrl);
      };
    } catch (e) {
      console.error("Error processing document data:", e);
      
      // Try alternative approach for base64 strings
      if (typeof data === 'string') {
        try {
          console.log("Attempting alternative data URI approach...");
          const dataUri = `data:${type};base64,${data.replace(/\s/g, '')}`;
          setViewUrl(dataUri);
          console.log("Successfully set data URI");
        } catch (altError) {
          console.error("Alternative approach also failed:", altError);
        }
      }
      return;
    }
  }, [data, format]);

  return (
    <Modal
      title={fileName}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={800}
    >
      {viewUrl && (
        <div style={{
          display: "flex", justifyContent: "center", alignItems: "center", padding: 0,
          height: "80vh",
          overflow: "hidden",
        }}>
          {[".png", ".jpeg", ".jpg"].includes(format) ? (
            <img
              src={viewUrl}
              alt="Preview"
              style={{
                maxHeight: "100%",
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <iframe
              src={viewUrl}
              title={fileName}
              style={{
                border: "none",
                width: "100%",
                height: "100%",
              }}
            />
          )}
        </div>
      )}
    </Modal>
  );
};

export default View;
